import React from 'react';
import { useLang } from '../../context/LanguageContext';
import { GEO_LABELS } from '../../data/geo';

// Answer-first block placed directly after the H1 (visible HTML, 40–90 words).
const AnswerBlock = ({ children, label }) => {
  const { lang } = useLang();
  return (
    <div className="mt-6 rounded-xl border-l-4 border-blue-600 bg-blue-50/70 px-5 py-4">
      <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-blue-700">{label || GEO_LABELS[lang].shortAnswer}</p>
      <p className="mt-2 text-[15.5px] text-slate-800 leading-relaxed">{children}</p>
    </div>
  );
};

export default AnswerBlock;
